import ItemContent from 'modules/stores/store/components/item-content'
import ItemWrapper from 'modules/stores/store/components/item-wrapper'
import { useLinkActions } from 'modules/stores/store/content/link/hooks/use-link-actions'
import { LinkItemViewType } from 'modules/stores/store/content/link/types/link-interface'
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item'
import { useChangeItemDraft } from '../../hooks/use-change-item-draft'
import { getComplexItemUpdateData } from '../../utils/get-complex-item-update-data'

const LinkContent = (linkView: LinkItemViewType) => {
  const { deleteLink, updateLink } = useLinkActions()

  const { onDelete } = useDeleteItem()

  const onDeleteLink = () =>
    onDelete({ deleteCallback: () => deleteLink(linkView.id), itemId: linkView.itemId })

  const { onChangeItemDraft } = useChangeItemDraft()

  const onSaveDraft = () => {
    return onChangeItemDraft({
      callback: async () => {
        await updateLink(
          linkView.id,
          getComplexItemUpdateData({
            ...linkView,
            draft: true,
          }),
        )
      },
      itemId: linkView.itemId,
      draft: true,
    })
  }

  const onPublish = () => {
    return onChangeItemDraft({
      callback: async () => {
        await updateLink(
          linkView.id,
          getComplexItemUpdateData({
            ...linkView,
            draft: false,
          }),
        )
      },
      itemId: linkView.itemId,
      draft: false,
    })
  }

  return (
    <ItemWrapper id={linkView.itemId}>
      <ItemContent
        draft={linkView.draft}
        onDelete={onDeleteLink}
        onSaveDraft={onSaveDraft}
        onPublish={onPublish}
        itemId={linkView.itemId}
        title={linkView.title}
        itemType={linkView.type}
        thumbnail={linkView.thumbnail}
      />
    </ItemWrapper>
  )
}

export default LinkContent
